export default class DeveloperSettingsController {
    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.tabs = [
            {
                title: 'Api Access',
                state: 'main.developer-settings.api-access'
            }
        ];
    }

    onTabClick({ tab }) {
        this.$state.go(tab.state);
    }
}



// WEBPACK FOOTER //
// ./app/components/developer-settings/developer-settings.controller.js